import React from 'react'
import { Translate } from '../../../language'


import style from './WhitOutPost.module.css'
const WhitOutPost = () => {
  return (
    <div className={style.text}>
        {Translate('whitOutPost','es')}
    </div>
  )
}

export default WhitOutPost